<script setup>

</script>

<template>
    <div class="flex flex-col items-center justify-center md:pt-44 position-fixed top-0 text-center px-4">
        <div class="max-w-lg  p-8 rounded-lg border dark:border-neutral-700">
            <i class="pi !text-xl px-3 rounded-xl mb-4 p-2" :class="{
                'pi-thumbs-up text-green-800 bg-green-200': $page.props.action === 'accept',
                'pi-ban text-red-800 bg-red-200': $page.props.action === 'rejected'
            }"></i>
            <h1 class="text-3xl font-bold text-gray-800 dark:text-gray-200 mb-4">{{ $page.props.action === 'accept' ? $t('reservations.change_accepted_title') : $t('reservations.change_rejected_title') }}</h1>
            <p class="text-gray-600 dark:text-gray-200 !leading-6">
                {{ $t('reservations.change_status_msg') }}
                <br>
                <br>
                {{ $t('reservations.change_close_hint') }}
            </p>

        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
